// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"56a3b8c7","228":"f514bdaa","655":"c1be888d","727":"116a9cef"}[chunkId] + ".chunk.css";
};